<template>
    <div class="register-container">
        <van-nav-bar title="讲座预约" left-arrow @click-left="
        () => {
          this.$router.go(-1);
        }
      "></van-nav-bar>

        <Banner />
        <van-form validate-first @submit="OnNext" class="form" v-show="!isQuestion">
            <div class="title">请填写个人基本信息</div>
            <div class="form-item">
                <van-field v-model="formData.Name" required name="Name" label="姓名" placeholder="请输入您的姓名" :rules="[{ required: true, message: '请输入您的姓名' }]" />
            </div>
            <!-- <div class="form-item">
                <van-field v-model="formData.IdCardType" required readonly name="IdCardType" label="证件类型"
                    placeholder="请选择证件类型" :rules="[{ required: true, message: '请输入正确的证件类型' }]"
                    @click="IdCardShow = true" />
            </div>-->
            <div class="form-item">
                <van-field v-model="formData.IdCard" required name="IdCard" label="身份证号码" placeholder="请输入您的身份证号码" :rules="[
            { validator: validatorIDCard, message: '请输入正确的证件号码' },
          ]" />
            </div>

            <div class="form-item">
                <van-field v-model="formData.Tel" required name="Tel" label="手机" placeholder="请输入您的手机号" :rules="[
            { validator: validatorPhone, message: '请输入正确的电话号码' },
          ]" />
            </div>

            <div class="form-item">
                <van-field type="number" required label="验证码" v-model="formData.Code" placeholder="请输入验证码（必填）">
                    <template #button>
                        <van-button color="#999" size="small" v-if="isSend">{{ count }}s</van-button>
                        <van-button color="#00a5e5" size="small" v-else @click="sendCode()">发送验证码</van-button>
                    </template>
                </van-field>
            </div>

            <!-- <div class="form-item">
                <van-field v-model="formData.Email" name="Email" label="邮箱" placeholder="请输入您的邮箱" />
            </div>

            <div class="form-item">
                <van-field v-model="formData.Company" name="Company" label="单位" placeholder="请输入您的单位" />
            </div>
            <div class="form-item">
                <van-field v-model="formData.Position" name="Position" label="职务" placeholder="请输入您的职务" />
            </div>
            <div class="form-item">
                <van-field v-model="formData.Address" readonly name="Address" label="地区" placeholder="请选择地区"
                    @click="areaShow = true" />
            </div>-->
            <!-- <uploadImg :imgUrl="formData.Photo | imgAddress" @OnUploadImg="UploadImg" labelName="免冠照上传"
            :Require="false"></uploadImg>-->
            <div class="forum">
                <div class="forum-title">预约讲座场次</div>
                <van-checkbox-group v-model="forumCheck">
                    <div class="forum-item" v-for="(item, index) in forumList" :key="index">
                        <van-checkbox icon-size="16" shape="square" :name="item.id">{{
              item.title
            }}</van-checkbox>
                    </div>
                </van-checkbox-group>
            </div>
            <div class="submit">
                <van-button block type="info" color="#00a5e5">提交</van-button>
            </div>
        </van-form>

        <van-dialog v-model="promptShow" title="温馨提示">
            <div class="dialog-box" v-html="defaultInfo.config.hint"></div>
        </van-dialog>
        <van-popup v-model="areaShow" position="bottom">
            <van-area title="地址" :area-list="areaList" value="330782" @confirm="onConfirm" @cancel="onCancel" />
        </van-popup>
        <van-popup v-model="IdCardShow" position="bottom">
            <van-picker title="证件类型" show-toolbar :columns="IdCardTypeList" @confirm="onIdCardTypeConfirm" @cancel="onIdCardTypeCancel" @change="onIdCardTypeChange" />
        </van-popup>
    </div>
</template>

<script>
import uploadImg from '@/components/UploadAvatar/index';
import areaList from '@/utils/area';
import Toast from 'vant/lib/toast';
import httpRequest from '@/module_visitor/api/http.js';
import { mapGetters } from 'vuex';
import { isPhone, isIdCard } from '@/utils/filters.js';
import Banner from '@/components/Common/banner';
export default {
    data() {
        return {
            count: 60,
            isSend: false,
            secrecy: '1',
            promptShow: true,
            isSubmit: false,
            areaList: areaList,
            areaShow: false,
            OtherShow: false,
            count: 0,
            Other: '',
            forumCheck: [],
            IdCardTypeList: ['身份证', '护照'],
            forumList: [],
            formData: {
                Code: '',
                Company: '',
                Position: '',
                Name: '',
                IdCard: '',
                Tel: this.$route.query.tel,
                TeamId: this.$route.query.teamId,
                CompanyId: this.$route.query.companyId,
                Email: '',
                Identitys: '2',
                Remark: '',
                Address: '',
                IdCardType: '身份证',
                Source: this.$route.query.source,
            },
            IdCardShow: false,
            VisitorTime: [],
            Source: 0,
            isQuestion: false,
            questionList: [],
            QuestionId: '',
            bannerList: [],
        };
    },
    computed: {
        ...mapGetters(['defaultInfo']),
    },
    watch: {},
    components: {
        uploadImg,
        Banner,
    },
    methods: {
        // 验证手机
        validatorPhone(val) {
            return /^1(3|4|5|6|7|8|9)[0-9]{9}$/.test(val);
        },

        // 验证身份证
        validatorIDCard(val) {
            if (this.formData.IdCardType == '身份证') {
                return isIdCard(val);
            } else {
                return true;
            }
        },

        // 发送验证码
        sendCode() {
            if (this.form.tel == '' || !isPhone(this.form.tel)) {
                Toast('请输入正确的手机号码！');
                return;
            }
            // Toast('体验码：8888');
            // return
            let params = {
                tel: this.form.tel,
            };
            httpRequest
                .post(`/api/visitor/sendCode`, params)
                .then(res => {
                    const { data, code, msg } = res.data;
                    if (code == 200) {
                        Toast.success('发送成功');
                        this.Countdown();
                    } else {
                        Toast.fail(msg);
                    }
                })
                .catch(error => {
                    console.log('🚀 ~ file: login.vue ~ line 93 ~ sendCode ~ error', error);
                });
        },

        onIdCardTypeChange() {},
        UploadImg(value) {
            this.formData.Photo = value;
        },
        onConfirm(val) {
            this.areaShow = false;
            this.formData.Address = val[0].name + ' ' + val[1].name + ' ' + val[2].name;
        },
        onIdCardTypeConfirm(val) {
            this.formData.IdCardType = val;
            this.IdCardShow = false;
        },
        onIdCardTypeCancel() {
            this.IdCardShow = false;
        },

        onCancel() {
            this.areaShow = false;
        },
        handleGetQuestion() {
            httpRequest.get(`/api/question/getQuestion`).then(res => {
                let data = res.data.data;
                if (res.data.code == 200) {
                    this.questionList = data;
                }
            });
        },

        OnNext() {
            this.OnSubmit();
        },

        OnPrevious() {
            this.isQuestion = false;
        },

        getData() {
            let params = {
                pageSize: 50,
                pageNum: 1,
            };
            httpRequest.get(`/api/forum/list`, params).then(res => {
                this.forumList = res.data.data.result;
            });
        },

        // 提交请求
        OnSubmit() {
            var model = [];
            try {
                if (this.forumCheck.length == 0) {
                    Toast(`请选择讲座`);
                    return;
                }

                this.formData.Remark = this.forumCheck.join(',');

                let params = {
                    ...this.formData,
                };

                this.handleRegister(params);
            } catch (e) {
                console.warn(e);
            }
        },

        // 注册
        handleRegister(model) {
            Toast.loading({
                message: '加载中...',
                forbidClick: true,
            });
            httpRequest
                .post(`/api/visitor/registerForum`, model)
                .then(res => {
                    const { code, data, msg } = res.data;
                    if (code == 200) {
                        Toast.clear();
                        Toast('登记成功');
                        window.localStorage.setItem('v_token', data);
                        this.$router.push({ path: '/entryCode' });
                    } else {
                        Toast(msg);
                    }
                })
                .catch(error => {
                    Toast.clear();
                });
        },
    },

    created() {
        this.getData();
    },
    mounted() {},
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/mixin.scss';

.register-container {
    width: 100%;
    min-height: 100%;

    .banner {
        width: 100%;

        .my-swipe {
            img {
            }
        }

        img {
            width: 100%;
        }
    }

    .title {
    }

    .form-item {
    }

    .forum {
        padding: 0 20px;

        .forum-title {
            font-size: 32px;
            margin-bottom: 10px;
            position: relative;
            padding-left: 24px;
        }

        .forum-title::before {
            position: absolute;
            left: 8px;
            color: #ee0a24;
            font-size: 14px;
            content: '*';
        }

        .forum-item {
            font-size: 30px;
            padding: 10px 20px;
        }
    }

    .submit {
    }

    .secrecy {
        display: flex;
        justify-content: center;
        padding: 20px 0;

        span {
            color: #2559c4;
            text-decoration: underline;
        }
    }

    .form {
        background: #fff;
        margin: 20px;
        padding: 20px;
        border-radius: 20px;

        .title {
            font-weight: bold;
            font-size: 34px;
            padding: 10px 20px;
        }

        .form-item {
            background: #fff;
            padding: 10px;

            .label {
                font-size: 28px;
                color: #646566;
                padding: 10px;

                span {
                    color: var(--theme_primary_color);
                    margin: 0 0px 0 6px;
                }
            }

            .form-item_group {
                padding: 20px 0;

                .checkbox {
                    font-size: 28px;
                    padding: 10px;
                    display: flex;
                }
            }
        }
    }

    .dialog-box {
        padding: 40px;

        p {
            padding: 10px;
        }
    }

    .question {
        padding: 10px;
        background: #fff;
        margin: 20px;

        .question-list {
            .question-title {
                font-weight: 600;
                padding: 20px 0;
            }

            div {
                .question-item {
                    display: flex;
                    flex-direction: column;
                    align-items: flex-start;
                    padding: 12px 0;

                    div {
                    }

                    .question-input {
                        height: 100px;
                        width: 100%;
                        outline: none;
                        border: none;
                        border-bottom: 1px solid #eaeaea;
                    }
                }
            }

            .question-item {
                display: flex;
                padding: 8px 10px;
                align-items: center;
            }
        }

        .submit {
            padding: 20px 10px;

            button {
                margin-bottom: 20px;
            }
        }
    }

    .other-answer_btn {
        padding: 20px;
    }

    .form {
        .form-item {
        }

        .submit {
            display: flex;

            button {
                margin: 20px;
            }

            .next {
                margin: 20px;
                padding: 0 15px;
                border-radius: 999px;
                width: 100%;
                font-size: 28px;
                text-align: center;
                line-height: 88px;
                height: 88px;
                background: #ff6666;
                color: #fff;
            }
        }
    }

    .cropper-wrapper {
        position: fixed;
        z-index: 99;
        left: 0;
        top: 0;
        height: 100%;
        width: 100%;

        .cropper-content {
            height: 90%;
        }

        .modify-img {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 20px;
        }
    }

    .dialog {
        margin-bottom: 20px;
    }
}
</style> 